// extracted by mini-css-extract-plugin
export var deliveryRow = "_so-a";
export var fixedHeight = "_so-4";
export var freightLogo = "_so-9";
export var fullWidth = "_so-3";
export var priceColumn = "_so-5";
export var radioSelected = "_so-7";
export var radioUnselected = "_so-6";
export var selectedOption = "_so-2";
export var selectedOptionContainer = "_so-1";
export var selection = "_so-0";
export var tallSkeletonText = "_so-8";